import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import AlertDialog from './AlertDialog.jsx'
import { Switch } from '@progress/kendo-react-inputs'
import { AutoSizer } from 'react-virtualized'
import {
    TreeList,
    orderBy,
    filterBy,
    mapTree,
    extendDataItem,
    TreeListTextFilter,
    TreeListDateFilter,
    TreeListBooleanFilter,
    treeToFlat,
    TreeListToolbar,
} from '@progress/kendo-react-treelist'
import { MultiSelect } from '@progress/kendo-react-dropdowns'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { getAPIURL, getBaseURL } from '../../GlobalComponents/URLs'
import { Notification, NotificationGroup } from '@progress/kendo-react-notification'
import { Fade } from '@progress/kendo-react-animation'
import AssetSelect from './AssetSelect.jsx'
import {
    custTagsAPIDataAdded,
    custTagsClearFiltersChanged,
    custTagsAPIDataChanged,
    custTagsDataStateChanged,
    custTagsColumnsChanged,
    custTagsClearSelectedTagUIDsChanged,
    custTagsCriteriaChanged,
} from '../../features/customerTags/customerTagsSlice'
import { assetSelectAssetSelectedChanged } from '../../features/assetSelect/assetSelectSlice.js'
import { appIsDirtyChanged } from '../../features/app/appSlice.js'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import _ from 'lodash' // cool kids know _ is low-dash
import { AWCButton, BUTTON_TYPES, FastQuoteInput } from '../../GlobalComponents/Inputs/Inputs'
import { custTreeViewListLoading } from '../../features/customerTreeView/customerTreeViewSlice.js'
import { formatDate } from '@telerik/kendo-intl'
import {
    ColumnMenuBooleanColumn,
    ColumnMenuDateColumn,
    ColumnMenuDateFilter,
} from '@progress/kendo-react-data-tools'
import { Checkbox } from '@progress/kendo-react-inputs'
import './CustomerTags.scss'
import { createSyntheticEvent } from '../../GlobalComponents/GlobalFunctions.tsx'
import AssetInfo from './AssetInfo.jsx'

const subItemsField = 'Log'
const expandField = 'expanded'
const selectField = 'Selected'

export default function CustomerTags({ CustomerTagsCriteria, CustomerTagFilters, onRowClick }) {
    //CustomerTags.whyDidYouRender = true
    let debugAllSites = false
    const [extendedFieldStyles, setExtendedFieldStyles] = useState('')
    //let extendedFieldStyles = ".CustomerTagsCol-ValveType{ min-Width: 340px; }"
    if (
        CustomerTagsCriteria.SelectedCustomerSites.AllSites !== undefined &&
        CustomerTagsCriteria.SelectedCustomerSites.AllSites
    )
        debugAllSites = true
    const dispatch = useDispatch()
    const assetFields = useSelector((state) => state.customerTagsReducer.assetFields)
    const assetSelected = useSelector((state) => state.assetSelectReducer.assetSelected)
    const clearFiltersRequested = useSelector((state) => state.customerTagsReducer.clearFilters)
    const data = useSelector((state) => state.customerTagsReducer.data)
    const serviceTypes = useSelector((state) => state.customerTagsReducer.serviceTypes)
    const criteria = useSelector((state) => state.customerTagsReducer.criteria)
    const lastDataRequest = useSelector((state) => state.customerTagsReducer.lastDataRequest)
    const lastDataRetrieval = useSelector((state) => state.customerTagsReducer.lastDataRetrieval)
    const dataState = useSelector((state) => state.customerTagsReducer.dataState)
    if (criteria === null) dispatch(custTagsDataStateChanged(initDataState()))
    const columns = useSelector((state) => state.customerTagsReducer.columns)
    const columnsSynched = useSelector((state) => state.customerTagsReducer.columnsSynched)
    //const columnsFullDisplay = useSelector(state => state.customerTagsReducer.columnsFullDisplay);
    const columnsFullDisplay = true // PIT as "toggle" to be removed after they asked for it to be implemented!
    const [expanded, setExpanded] = useState([])
    const [table, setTable] = useState(null)
    const [_export, set_Export] = useState(null)
    const [showSparePool, setShowSparePool] = useState(false)
    const [spareNumber, setSpareNumber] = useState(0)
    // React.useEffect(() => {
    //     if (data !== processedData.data) {
    //         dispatch(custTagsColumnsChanged(initColumns()))
    //     }
    // }, [dataState])
    let filteredTreeData = React.useRef([])
    // Throbber for Excel export
    const [throbberExcelExport, setThrobberExcelExport] = useState({
        status: 'stand-by',
        isExporting: false,
    })
    // Throbber for Documentation download
    const [throbberDocumentationDownload, setThrobberDocumentationDownload] = useState({
        status: 'stand-by',
        isDownloading: false,
    })
    const [excelExportDialog, setExcelExportDialog] = useState({
        visible: false,
        excelExportDiv: '',
    })
    const [excelExportParams, setExcelExportParams] = useState({
        includeAllLogs: false,
        includeAllSelectedLogs: true,
    })
    const isDirty = useSelector((state) => state.appReducer.isDirty)
    const initColumns = () => {
        function compositeWithoutCurrentFieldFilter(field, filter) {
            // create a composite filter excluding current column
            var i, j
            let compFilter = []
            for (i in filter) {
                if (filter[i].field !== field) {
                    if (Array.isArray(filter[i].value)) {
                        // Multi-select filters
                        let filters = []
                        for (j in filter[i].value) {
                            filters.push({
                                field: filter[i].field,
                                operator: 'eq',
                                value: filter[i].value[j],
                            })
                        }
                        if (filters.length > 0) compFilter.push({ logic: 'or', filters: filters })
                    } else {
                        // Single-value filters
                        let flt = _.cloneDeep(filter[i])
                        // Modify boolean filters that are "eq" : false to "ne" : true
                        if (flt.value === false && flt.operator === 'eq') {
                            flt.operator = 'neq'
                            flt.value = true
                        }
                        compFilter.push(flt)
                    }
                }
            }
            return compFilter
        }

        function multiSelectItemRender(li, itemProps) {
            const itemChildren = (
                <span>
                    <input
                        type='checkbox'
                        checked={itemProps.selected}
                        onChange={(e) => itemProps.onClick(itemProps.index, e)}
                    />
                    &nbsp;{li.props.children}
                </span>
            )
            return React.cloneElement(li, li.props, itemChildren)
        }

        function MultiSelectTextFilter(props) {
            let idField = props.field
            // Bind id from different field
            if (props.field.toUpperCase() === 'PROJECTNAME') idField = 'ProjectID'
            let filteredData = filterBy(
                [...data],
                compositeWithoutCurrentFieldFilter(idField, props.filter),
                ''
            ) //change "" to subItemsField to filter into history
            let options = []
            for (var i in filteredData) {
                if (filteredData[i][props.field] !== undefined) {
                    var includes = false
                    for (var j = 0; j < options.length; j++) {
                        // convert to string first in case integer but make case insensitive
                        if (
                            options[j].id.toString().toUpperCase() ===
                            filteredData[i][idField].toString().toUpperCase()
                        ) {
                            includes = true
                            break
                        }
                    }
                    if (!includes) {
                        options.push({
                            text: filteredData[i][props.field],
                            id: filteredData[i][idField],
                        })
                    }
                }
            }

            if (options.length > 0) {
                // Sort options...
                options.sort((a, b) => {
                    var textA = a.text.toUpperCase()
                    var textB = b.text.toUpperCase()
                    if (textA < textB) return -1
                    if (textA > textB) return 1
                    return 0
                })
                if (idField.toUpperCase() === 'SERVICETYPE') {
                    var newOptions = []
                    for (i in serviceTypes) {
                        for (j in options) {
                            if (serviceTypes[i].id === options[j].id) {
                                newOptions.push(serviceTypes[i])
                                break
                            }
                        }
                    }
                    options = newOptions
                }
            } else {
                if (idField.toUpperCase() === 'SITE') {
                }
                //Add Query String Option
                if (CustomerTagFilters.ProjectID !== null && idField === 'ProjectID')
                    options.push({
                        text: 'Your Project / Turnaround',
                        id: parseInt(CustomerTagFilters.ProjectID),
                    })
            }

            // defaultValue is an Array of options found in filteredData
            // required for dismount/remount (adaptive reasons)
            let defaultValue = []
            // Load defaultValue with options[].id found in filter set
            for (i in props.filter) {
                if (props.filter[i].field === idField) {
                    for (j in options) {
                        let filterSet = props.filter[i].value
                        for (var k in filterSet) {
                            if (options[j].id === filterSet[k]) defaultValue.push(options[j])
                        }
                    }
                    break
                }
            }
            return (
                <MultiSelect
                    data={options}
                    itemRender={multiSelectItemRender}
                    className={'CustomerTagsCol-' + props.field} //Control widths in css
                    defaultValue={defaultValue}
                    textField='text'
                    dataItemKey='id'
                    placeholder='-- All --'
                    filterable={true}
                    onChange={(event) => {
                        // strip id out of value pair
                        let id = []
                        for (var i = 0; i < event.target.value.length; i++) {
                            id.push(event.target.value[i].id)
                        }
                        props.onFilterChange({
                            filter: [
                                {
                                    value: id !== defaultValue ? id : '',
                                    field: idField,
                                    operator: 'eq',
                                    ignoreCase: 'true',
                                    type: 'MultiSelect', //added this for handleDataStateChange
                                },
                            ],
                            field: props.field,
                            syntheticEvent: event.syntheticEvent,
                        })
                    }}
                />
            )
        }

        function TextFilter(props) {
            return (
                <div className={'CustomerTagsCol-' + props.field}>
                    <TreeListTextFilter
                        field={props.field}
                        filter={props.filter}
                        onFilterChange={props.onFilterChange}
                        operators={props.operators}
                    />
                </div>
            )
        }

        let checkboxChecked = false

        const CustomSelectAllFilter = (props) => {
            function selectChanged(e) {
                checkboxChecked = e.target.checked
                let newApiData = _.cloneDeep(data) // lodash
                // Update redux state with checked/unchecked for all items
                // for (var i in newApiData) {
                //     newApiData[i].Selected = e.target.checked
                //     for (var j in newApiData[i].Log) {
                //         // Don't automatically check logs
                //         newApiData[i].Log[j].Selected = false
                //     }
                // }
                newApiData.forEach((i) => {
                    if (filteredTreeData.current.length > 0) {
                        filteredTreeData.current.forEach((oId) => {
                            if (i.OrderTagId === oId) {
                                i.Selected = e.target.checked
                            }
                        })
                    } else {
                        i.Selected = e.target.checked
                    }
                    if (i.Log) {
                        i.Log.forEach((j) => {
                            j.Selected = false
                        })
                    }
                })
                dispatch(custTagsAPIDataChanged(newApiData))
            }

            // Something exists, allow select all
            if (processedData.data && processedData.data.length > 0) {
                return (
                    <input
                        type='checkbox'
                        onChange={selectChanged}
                        checked={checkboxChecked}
                        style={{ paddingLeft: 10 }}
                    />
                )
            } else {
                return <div style={{ paddingLeft: 10 }}></div>
            }
        }

        function SelectCell(props) {
            const { dataItem, field } = props
            const cellData = dataItem[field]
            // Need to force an updated copy of data here as it doesn't get refreshed!
            let data = useSelector((state) => state.customerTagsReducer.data)

            function selectChanged(e) {
                checkboxChecked = false
                let newApiData = _.cloneDeep(data) // lodash
                for (var i in newApiData) {
                    if (newApiData[i].OrderTagId === dataItem.OrderTagId)
                        newApiData[i].Selected = !newApiData[i].Selected
                    for (var j in newApiData[i].Log) {
                        if (newApiData[i].Log[j].OrderTagId === dataItem.OrderTagId)
                            newApiData[i].Log[j].Selected = !newApiData[i].Log[j].Selected
                    }
                }
                dispatch(custTagsAPIDataChanged(newApiData))
                e.stopPropagation()
            }
            return (
                <td
                    className='k-grid-content-sticky k-text-nowrap'
                    role='gridcell'
                    aria-colindex='0'
                    colSpan='1'
                    style={{
                        left: '0px',
                        right: '0px',
                        display: 'table-cell',
                        textAlign: 'center',
                    }}
                >
                    <input type='checkbox' checked={cellData} onChange={selectChanged} />
                </td>
            )
        }

        function TestReportFilter(props) {
            return (
                <div
                    className='k-icon k-i-paste-plain-text'
                    style={{ fontSize: '20px', padding: '3px 0px 0px 29px' }}
                ></div>
            )
        }

        function testReportCell(props) {
            const { dataItem, field } = props
            const cellData = dataItem[field]
            let className = ''
            if (cellData) className = 'k-icon k-i-paste-plain-text'
            let title = ''
            let onClick = ''
            if (dataItem.DateTested !== undefined) {
                title =
                    'Download Test Report from ' + dataItem.DateTested.toLocaleDateString('en-US')
                onClick = (e) => testReportCellOnClick(dataItem.OrderTagId, e)
            }
            return (
                <td
                    className={className}
                    title={title}
                    onClick={onClick}
                    style={{
                        fontSize: '20px',
                        display: 'table-cell',
                        textAlign: 'center',
                    }}
                ></td>
            )
        }

        function testReportCellOnClick(orderTagId, e) {
            let selectedOrderTagId = [orderTagId]
            let reportTypes = [1] // Test Report
            let apiParams = {
                orderTagIds: selectedOrderTagId,
                reportTypes: reportTypes,
            }
            downloadDocumentation(apiParams)
            e.stopPropagation()
        }

        function dispositionHeaderCell(props) {
            const { field, onClick, selectionChange, children } = props
            return (
                <span className='k-link' onClick={onClick} onChange={selectionChange}>
                    {' '}
                    {field}
                    <div
                        className='k-icon k-i-info'
                        title='Identifies whether the asset is active, a spare, or scrapped.'
                        style={{
                            fontSize: 'small',
                            themeColor: 'info',
                            padding: '0px 2px 2px 2px',
                        }}
                    />
                    {children}
                </span>
            )
        }

        function dispositionCell(props) {
            const { dataItem, field } = props
            const cellData = dataItem[field]
            const dataColor =
                cellData === 'Spare'
                    ? 'limegreen'
                    : cellData === 'Scrapped'
                        ? 'red'
                        : 'currentcolor'
            return (
                <td>
                    <span style={{ color: dataColor }}>{cellData}</span>
                </td>
            )
        }

        let cols = []
        let newExtendedFieldStyles = ''
        let i = 0
        cols.push({
            field: 'Selected',
            title: 'Select',
            cell: SelectCell,
            hidden: true,
            columnMenu: CustomSelectAllFilter,
            // filter: SelectFilter,
            locked: true,
        })
        cols.push({
            field: 'TagUID',
            title: 'AWC ID',
            expandable: true,
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'AWC ID'} />
            },
            locked: true,
        })
        cols.push({
            field: 'Tag',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Tag'} />
            },
            locked: true,
        })
        cols.push({
            field: 'ProcessUnit',
            title: 'Process Unit',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Process Unit'} />
            },
        })
        cols.push({
            field: 'TestReport',
            title: 'Test Report',
            hidden: true,
            cell: testReportCell,
            columnMenu: CustomTestReportFilter,
            // filter: TestReportFilter,
        })
        cols.push({
            field: 'AssetType',
            // minResizableWidth: 340,
            title: 'Asset Type',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Asset Type'} />
            },
        })
        cols.push({
            field: 'ValveManufacturer',
            title: 'Manufacturer',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Manufacturer'} />
            },
        })
        cols.push({
            field: 'ValveModelNo',
            title: 'Model #',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Model #'} />
            },
        })
        cols.push({
            field: 'SerialNumber',
            title: 'S/N',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'S/N'} />
            },
        })
        cols.push({
            field: 'CustomerOrderNumber',
            title: 'Purchase Order #',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Purchase Order #'} />
            },
        })
        cols.push({
            field: 'OrderDate',
            title: 'Order Date',
            width: '100px',
            columnMenu: CustomDateFilter,
            format: '{0:d}',
        })
        if (!showSparePool) {
            cols.push({
                field: 'Disposition',
                // headerCell: dispositionHeaderCell,
                cell: dispositionCell,
                columnMenu: (props) => {
                    return <CustomCheckboxFilter {...props} title={'Disposition'} />
                },
            })
        } else {
            cols.push({
                field: 'Disposition',
                // headerCell: dispositionHeaderCell,
                cell: dispositionCell,
            })
        }

        cols.push({
            field: 'Milestone',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Milestone'} />
            },
        })
        //Don't show customers the stage (controlled at Api)
        for (i in data) {
            if (data[i].Stage !== undefined) {
                cols.push({
                    field: 'Stage',
                    columnMenu: (props) => {
                        return <CustomCheckboxFilter {...props} title={'Stage'} />
                    },
                    width: '200px',
                })
                break
            }
        }
        cols.push({
            field: 'ServiceType',
            title: 'Service',
            columnMenu: (props) => {
                return <CustomCheckboxFilter {...props} title={'Service'} />
            },
        })
        cols.push({
            field: 'DateTested',
            title: 'Date Tested',
            width: '100px',
            columnMenu: CustomDateFilter,
            format: '{0:d}',
        })
        // Only include Turnaround if contents exist
        let incCol = false
        if (!incCol) {
            for (i in data) {
                if (data[i].ProjectName !== undefined) {
                    incCol = true
                    break
                }
            }
        }
        if (incCol)
            cols.push({
                field: 'ProjectName',
                title: 'Turnaround',
                width: '130px',
                columnMenu: (props) => {
                    return <CustomCheckboxFilter {...props} title={'Turnaround'} />
                },
            })

        // Only show these columns when "More" is selected...
        if (columnsFullDisplay !== undefined && columnsFullDisplay) {
            // Only include FM Cert if contents exist
            let incCol = false
            for (i in data) {
                if (data[i].ValveFM !== undefined) {
                    incCol = true
                    break
                }
            }
            if (incCol)
                cols.push({
                    field: 'ValveFM',
                    title: 'FM Cert.',
                    columnMenu: (props) => {
                        return <CustomCheckboxFilter {...props} title={'FM Cert.'} />
                    },
                })

            cols.push({
                field: 'Shop',
                title: 'Shop',
                columnMenu: (props) => {
                    return <CustomCheckboxFilter {...props} title={'Shop'} />
                },
            })
            cols.push({
                field: 'OrderNumber',
                title: 'AWC S.O. #',
                columnMenu: (props) => {
                    return <CustomCheckboxFilter {...props} title={'AWC S.O. #'} />
                },
            })
            cols.push({
                field: 'DateReceived',
                title: 'Asset Received',
                width: '100px',
                columnMenu: CustomDateFilter,
                format: '{0:d}',
            })
            // cols.push({ field:"NeedDate", title:"Date Req", width:"100px", filter:TreeListDateFilter, format:"{0:d}" });
            cols.push({
                field: 'PlannedDeliveryDate',
                title: 'Planned Delivery',
                width: '100px',
                columnMenu: CustomDateFilter,
                format: '{0:d}',
            })
            cols.push({
                field: 'TechUsername',
                title: 'Tech',
                columnMenu: (props) => {
                    return <CustomCheckboxFilter {...props} title={'Tech'} />
                },
            })

            // // Don't show customer their account code
            for (i in data) {
                if (data[i].CustomerAccountCode !== undefined) {
                    cols.push({
                        field: 'CustomerAccountCode',
                        title: 'Account Code',
                        columnMenu: (props) => {
                            return <CustomCheckboxFilter {...props} title={'Account Code'} />
                        },
                    })
                    break
                }
            }
            //Don't show customers the Service Description (controlled at Api)
            for (i in data) {
                if (data[i].ServiceDescription !== undefined) {
                    cols.push({
                        field: 'ServiceDescription',
                        title: 'Service Description',
                        width: '220px',
                        columnMenu: (props) => {
                            return <CustomCheckboxFilter {...props} title={'Service Description'} />
                        },
                        // minResizableWidth: '220px',
                    })
                    break
                }
            }
            // Only include Site column if contents vary or searching for a tag results in a single result
            let site = ''
            for (i in data) {
                if (site === '') site = data[i].Site
                if (data[i].Site !== site || data.length === 1) {
                    cols.push({
                        field: 'Site',
                        title: 'Site',
                        // width: '220px',
                        columnMenu: (props) => {
                            return <CustomCheckboxFilter {...props} title={'Site'} />
                        },
                    })
                    break
                }
            }
        }

        // Asset specific columns
        let j = 0
        for (j in assetFields) {
            // Only include if contents exist
            for (i in data) {
                if (data[i][assetFields[j].field] !== undefined) {
                    let assetFilter
                    switch (assetFields[j].filter) {
                        case 'MultiSelectTextFilter':
                            assetFilter = MultiSelectTextFilter
                            break
                        case 'TreeListBooleanFilter':
                            assetFilter = TreeListBooleanFilter
                            break
                        default:
                            assetFilter = TextFilter
                    }
                    cols.push({
                        field: assetFields[j].field,
                        title: assetFields[j].title,
                        // filter: assetFilter,
                        columnMenu: (props) => {
                            return (
                                <CustomCheckboxFilter
                                    {...props}
                                    title={`${assetFields[j].title}`}
                                />
                            )
                        },
                    })
                    // Add style for generated classname
                    newExtendedFieldStyles +=
                        '.CustomerTagsCol-' +
                        assetFields[j].field +
                        '{ min-Width: ' +
                        assetFields[j].minWidth.toString() +
                        'px;}  '
                    break
                }
            }
        }

        //cols.push({ field:"Status", title: "Milestone", cell: stageProgressCell });
        //cols.push({ field:"isQuote", width:"80px", title:"Quote", filter: TreeListBooleanFilter});
        // Show OrderTagId for development only
        if (window.location.hostname.toUpperCase().includes('LOCALHOST'))
            cols.push({ field: 'OrderTagId', title: 'OT-ID', width: '80px' })
        //-------------------------------------------------

        setExtendedFieldStyles(newExtendedFieldStyles)
        return cols
    }

    const InsightCustomCheckboxFilter = (props) => {
        const { filter, onFilterChange, newData } = props

        const [filterData, setFilterData] = useState(newData)
        const [searchValue, setSearchValue] = useState('')

        useEffect(() => {
            if (searchValue) {
                const tempData = newData.filter((d) =>
                    d.toString().toLowerCase().includes(searchValue.toLowerCase())
                )
                const newFilter = {
                    ...filter,
                    value: tempData,
                }
                const event = new Event('change ', { bubbles: true })
                const fakeEvent = createSyntheticEvent(event)

                onFilterChange.call(undefined, fakeEvent, newFilter, filter)
                setFilterData(tempData)
            } else {
                setFilterData(newData)
            }
        }, [searchValue])

        const inputChange = React.useCallback(
            (event) => {
                const newFilter = {
                    ...filter,
                    value: filter.value.includes(event.value)
                        ? filter.value.filter((f) => f !== event.value)
                        : [event.value, ...filter.value],
                }
                setAllChecked(filterData.every((item) => newFilter.value.includes(item)))

                onFilterChange.call(undefined, event.syntheticEvent, newFilter, filter)
            },
            [filter, onFilterChange]
        )
        const [allChecked, setAllChecked] = useState(
            filterData.every((item) => filter.value.includes(item))
        )

        const toggleAll = (event) => {
            setAllChecked(event.value)

            if (event.value) {
                const newFilter = {
                    ...filter,
                    value: filterData,
                }
                onFilterChange.call(undefined, event.syntheticEvent, newFilter, filter)
            } else {
                const newFilter = {
                    ...filter,
                    value: [],
                }
                onFilterChange.call(undefined, event.syntheticEvent, newFilter, filter)
            }
        }

        return (
            <>
                <div
                    style={{
                        overflow: 'auto',
                        textAlign: 'center',
                        fontWeight: 'bold',
                    }}
                >
                    {props.title}
                </div>
                <div className='divider' />
                {/* <div
                    style={{
                        overflow: 'auto',
                        textAlign: 'center',
                        fontWeight: 'bold',
                    }}
                >
                    {filterData.length > 1 && (
                        <Checkbox
                            onChange={(event) => toggleAll(event)}
                            checked={allChecked}
                            label={'Check All'}
                            labelPlacement="after"
                        />
                    )}
                </div> */}
                <div style={{ padding: 10 }}>
                    <FastQuoteInput
                        maxLength='30'
                        value={searchValue}
                        onChange={(val) => {
                            setSearchValue(val)
                        }}
                        placeholder={'Search...'}
                    />
                </div>
                <div style={{ overflow: 'auto', padding: 10, maxHeight: 200 }}>
                    {filterData.length > 1 && !searchValue && (
                        <div style={{ fontWeight: 'bold' }}>
                            <Checkbox
                                onChange={(event) => toggleAll(event)}
                                checked={allChecked}
                                label={'(Check All)'}
                                labelPlacement='after'
                            />
                        </div>
                    )}
                    {filterData.length > 0 ? (
                        filterData.map((i) => (
                            <React.Fragment key={i}>
                                <Checkbox
                                    onChange={(event) =>
                                        inputChange({
                                            syntheticEvent: event.syntheticEvent,
                                            value: i,
                                        })
                                    }
                                    checked={filter.value.includes(i)}
                                    label={String(i)}
                                    labelPlacement='after'
                                />
                                <br />
                            </React.Fragment>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', fontSize: 20 }}>No data</div>
                    )}
                </div>
            </>
        )
    }

    const ColumnMenuCustomCheckboxesColumn = (props) => {
        const [newData, setNewData] = useState(props.data)
        const initialFilter = React.useCallback(
            (field) => ({
                logic: 'or',
                filters: [
                    {
                        operator: (current, values) => values.includes(current),
                        field,
                        value:
                            // props.field === 'Disposition'
                            //     ? newData.filter((item) => item !== 'Spare' && item !== 'Scrapped')
                            newData.filter((item) => item),
                    },
                ],
            }),
            []
        )

        useEffect(() => {
            const tempFilter = []
            for (let i in props.filter) {
                for (let j in props.filter[i].filters) {
                    if (props.filter[i].filters[j].field !== props.field) {
                        tempFilter.push({ logic: 'or', filters: props.filter[i].filters })
                    }
                }
            }
            const filteredData = filterBy([...processedData.data], tempFilter, subItemsField)
            // const tempData = Array.from(new Set(filteredData.map((a) => a[props.field])))
            const tempData = []
            filteredData.forEach((a) => {
                tempData.push(a[props.field])

                if (a.Log) {
                    a.Log.forEach((b) => {
                        tempData.push(b[props.field])
                    })
                }
            })
            let newList = Array.from(new Set(tempData))
            setNewData(newList)
        }, [props])

        return (
            <ColumnMenuBooleanColumn
                {...props}
                sortAsc={false}
                sortDesc={false}
                expandFilters={true}
                filterContent={[
                    (props2) => (
                        <InsightCustomCheckboxFilter
                            {...props2}
                            newData={newData.filter((item) => item)}
                            title={props.title}
                        />
                    ),
                ]}
                initialFilter={initialFilter}
            />
        )
    }

    const ColumnMenuCustomCheckbox = (props) => {
        const fieldName = props.field
        let dataList = []
        if (processedData.data && processedData.data.length > 0) {
            let tempList = []
            processedData.data.forEach((a) => {
                tempList.push(a[fieldName])
                if (a.Log) {
                    a.Log.forEach((b) => {
                        tempList.push(b[fieldName])
                    })
                }
            })
            dataList = new Set(tempList)
        }

        if (Array.from(dataList).filter((item) => item).length === 0) {
            return <div style={{ paddingLeft: 10 }}></div>
        }
        return <ColumnMenuCustomCheckboxesColumn {...props} data={Array.from(dataList).sort()} />
    }

    const CustomCheckboxFilter = (props) => {
        return <ColumnMenuCustomCheckbox {...props} processedCheckboxData={processedData.data} />
    }

    const ColumnMenuBooleanFilter = (props) => {
        const filter = props.filter
        const onFilterChange = props.onFilterChange
        const inputChange = React.useCallback(
            (event) =>
                onFilterChange.call(
                    undefined,
                    event.syntheticEvent,
                    {
                        ...filter,
                        value: event.value,
                    },
                    filter
                ),
            [filter, onFilterChange]
        )
        return (
            <div style={{ overflow: 'auto', padding: 10 }}>
                <Checkbox
                    onChange={inputChange}
                    checked={filter.value}
                    label='Test Report'
                    labelPlacement='after'
                />
            </div>
        )
    }

    const CustomTestReportFilter = (props) => {
        const initialFilter = React.useCallback(
            (field) => ({
                logic: 'and',
                filters: [
                    {
                        operator: 'eq',
                        field,
                        value: false,
                    },
                ],
            }),
            []
        )

        if (processedData && processedData.data.length > 0) {
            return (
                <ColumnMenuBooleanColumn
                    {...props}
                    sortAsc={false}
                    sortDesc={false}
                    expandFilters
                    filterContent={[ColumnMenuBooleanFilter]}
                    initialFilter={initialFilter}
                />
            )
        } else {
            return <div style={{ paddingLeft: 10 }}></div>
        }
    }

    // const ColumnMenuCustomDateFilter = (props) => {
    //     const { filter, onFilterChange } = props

    //     const dateChange = React.useCallback(
    //         (event) =>
    //             onFilterChange.call(
    //                 undefined,
    //                 event.syntheticEvent,
    //                 { ...filter, value: event.value },
    //                 filter
    //             ),
    //         [filter, onFilterChange]
    //     )

    //     var textLabel = 'To'
    //     if (filter.operator == 'gte') {
    //         textLabel = 'From'
    //     }
    //     return (
    //         <div style={{ margin: 20 }}>
    //             <span style={{ fontSize: 16 }}>{textLabel}</span>
    //             <DatePicker onChange={dateChange} value={filter.value} format={'MM/dd/yyyy'} />
    //         </div>
    //     )
    // }

    const CustomDateFilter = (props) => {
        const initialFilter = React.useCallback(
            (field) => ({
                logic: 'or',
                filters: [
                    {
                        field,
                        operator: 'eq',
                        value: new Date(),
                    },
                ],
            }),
            []
        )

        if (processedData.data.length === 0) {
            return <div style={{ paddingLeft: 10 }}></div>
        }

        return (
            <ColumnMenuDateColumn
                {...props}
                sortAsc={false}
                sortDesc={false}
                expandFilters={true}
                initialFilter={initialFilter}
                filterContent={[ColumnMenuDateFilter]}
            />
        )
    }

    // Reset Columns after api call...
    React.useEffect(() => {
        if (columnsSynched !== undefined && !columnsSynched)
            dispatch(custTagsColumnsChanged(initColumns()))

        // // commented out to stop infinite loop - underlying issue needs to be corrected
        // // failed test 10022
        // if (CustomerTagsCriteria.SelectedOrderTagIds.length > 0 && data.length > 0) {
        //     // tag history (child) item chosen. find parent item and expand.
        //     const tagDataItem = data.find(
        //         (d) =>
        //             d.Log &&
        //             d.Log.length > 0 &&
        //             d.Log.some((l) => l.OrderTagId === CustomerTagsCriteria.SelectedOrderTagIds[0])
        //     )
        //     if (tagDataItem) onExpandChange({ value: false, dataItem: tagDataItem })
        // }
    }, [data, columnsSynched, initColumns, dispatch])

    React.useEffect(() => {
        if (CustomerTagsCriteria.SelectedOrderDetailId > -1 &&
            data.length === 1 && data[0].OrderTagId > 0)
            onRowClick({ dataItem: { OrderTagId: data[0].OrderTagId } })
    }, [data])

    function initDataState() {
        // Don't include quotes as a default
        // let newFilter = [{value: false, field: "isQuote", operator: "eq"}];
        let newFilter = []
        // For QR scan...
        if (CustomerTagFilters.TagUID != null)
            newFilter.push({
                value: CustomerTagFilters.TagUID,
                field: 'TagUID',
                operator: 'eq',
            })
        // For Projects and Turnarounds Email links...
        if (CustomerTagFilters.ProjectID != null)
            newFilter.push({
                value: [parseInt(CustomerTagFilters.ProjectID)],
                field: 'ProjectID',
                operator: 'eq',
            })

        return {
            sort: [{ field: 'OrderDate', dir: 'desc' }],
            filter: newFilter,
        }
    }

    // Filter section-----------------------------------------------------------
    function clearFilters() {
        dispatch(custTagsDataStateChanged(initDataState()))
        dispatch(custTagsColumnsChanged(initColumns()))
        dispatch(custTagsClearSelectedTagUIDsChanged(true))
        dispatch(assetSelectAssetSelectedChanged({ ID: -1, Name: 'Default' }))
        // Clear redux store of checked items
        if (bRowsSelected) {
            let newApiData = _.cloneDeep(data) // lodash
            for (var i in data) {
                newApiData[i].Selected = false
                for (var j in newApiData[i].Log) {
                    newApiData[i].Log[j].Selected = false
                }
            }
            dispatch(custTagsAPIDataChanged(newApiData))
        }
    }

    // API Calls----------------------------------------------------------------
    React.useEffect(() => {
        function convertAPIData(apiData) {
            let convertedData = []
            for (var i in apiData) {
                //add selectable box
                apiData[i].Selected = false
                //convert date fields to JSON date functions
                apiData[i].OrderDate = new Date(apiData[i].OrderDate)
                apiData[i].NeedDate = new Date(apiData[i].NeedDate)
                if (apiData[i].DateReceived !== null && apiData[i].DateReceived !== undefined)
                    apiData[i].DateReceived = new Date(apiData[i].DateReceived)

                if (
                    apiData[i].PlannedDeliveryDate !== null &&
                    apiData[i].PlannedDeliveryDate !== undefined
                )
                    apiData[i].PlannedDeliveryDate = new Date(apiData[i].PlannedDeliveryDate)
                if (apiData[i].DateTested !== null && apiData[i].DateTested !== undefined)
                    apiData[i].DateTested = new Date(apiData[i].DateTested)

                //set booleans to false if undefined
                //if (apiData[i].ValveFM === undefined) apiData[i].ValveFM = false; took off since most of the time it n/a

                //create a test set for sparkline
                // let percent = 50;
                // let alertLevel = 0;
                // let alertNotes = "";
                // if (new Date() > apiData[i].NeedDate) {
                //     alertLevel=2;
                //     alertNotes = "Required Date has passed!";
                // }
                // if (apiData[i].Stage.toUpperCase().includes("COMPLETED") ||
                //     apiData[i].Milestone.toUpperCase().includes('CLOSED')) {
                //     percent=100;
                //     alertLevel=0;
                //     alertNotes = "";
                // }
                // if (apiData[i].Stage.toUpperCase().includes("NEW")) percent=10;
                // apiData[i].Status={Stage: apiData[i].Milestone, Percent: percent,
                //     AlertLevel: alertLevel, AlertNotes: alertNotes};

                for (var j in apiData[i].Log) {
                    // apiData[i].Log[j].Status={Stage: apiData[i].Log[j].Milestone, Percent: percent,
                    //     AlertLevel: alertLevel, AlertNotes: alertNotes};

                    //add selectable box
                    apiData[i].Log[j].Selected = false

                    apiData[i].Log[j].OrderDate = new Date(apiData[i].Log[j].OrderDate)
                    apiData[i].Log[j].NeedDate = new Date(apiData[i].Log[j].NeedDate)
                    if (
                        apiData[i].Log[j].DateReceived !== null &&
                        apiData[i].Log[j].DateReceived !== undefined
                    )
                        apiData[i].Log[j].DateReceived = new Date(apiData[i].Log[j].DateReceived)
                    if (
                        apiData[i].Log[j].PlannedDeliveryDate !== null &&
                        apiData[i].Log[j].PlannedDeliveryDate !== undefined
                    )
                        apiData[i].Log[j].PlannedDeliveryDate = new Date(
                            apiData[i].Log[j].PlannedDeliveryDate
                        )
                    if (
                        apiData[i].Log[j].DateTested !== null &&
                        apiData[i].Log[j].DateTested !== undefined
                    )
                        apiData[i].Log[j].DateTested = new Date(apiData[i].Log[j].DateTested)

                    //set booleans to false if undefined
                    //if (apiData[i].Log[j].ValveFM === undefined) apiData[i].Log[j].ValveFM = false; took off since most of the time it n/a
                }
                convertedData.push(apiData[i])
            }
            return convertedData
        }

        // Only call API if parameters have changed
        // if (CustomerTagsCriteria !== criteria) {
        if (JSON.stringify(CustomerTagsCriteria) !== JSON.stringify(criteria)) {
            // Save criteria so we don't call again!
            dispatch(custTagsCriteriaChanged(CustomerTagsCriteria))

            if (
                CustomerTagsCriteria.SelectedCustomerSites.AllSites ||
                (CustomerTagsCriteria.SelectedCustomerSites.Entities !== undefined &&
                    CustomerTagsCriteria.SelectedCustomerSites.Entities.length > 0) ||
                CustomerTagsCriteria.SelectedCustomerTags.length > 0 ||
                CustomerTagsCriteria.SelectedOrderDetailId > -1
            ) {
                //Clear any previous export notifications
                if (
                    throbberExcelExport.isExporting !== false ||
                    throbberExcelExport.status !== 'stand-by'
                )
                    setThrobberExcelExport({ status: 'stand-by', isExporting: false })
                if (
                    throbberDocumentationDownload.isDownloading ||
                    throbberDocumentationDownload.status !== 'stand-by'
                )
                    setThrobberDocumentationDownload({
                        status: 'stand-by',
                        isDownloading: false,
                    })

                var apiParams = {
                    entities: CustomerTagsCriteria.SelectedCustomerSites.Entities,
                    allSites: CustomerTagsCriteria.SelectedCustomerSites.AllSites,
                    tagUID: CustomerTagsCriteria.SelectedCustomerTags,
                    orderTagId: CustomerTagsCriteria.SelectedOrderTagIds,
                    assetType: CustomerTagsCriteria.SelectedAssetType.ID,
                    orderDetailId: CustomerTagsCriteria.SelectedOrderDetailId,
                }
                let tree_url = getAPIURL() + 'lcm/customertags'
                dispatch(custTreeViewListLoading(true))

                fetch(tree_url, {
                    credentials: 'include',
                    method: 'post',
                    body: JSON.stringify(apiParams),
                    headers: { 'Content-type': 'application/json' },
                })
                    .then((resp) => {
                        if (resp.ok) {
                            return resp.json()
                        } else throw new Error('bad request ' + resp.statusText)
                    })
                    .then((json) => {
                        if (json.CustomerTags.length > 0) {
                            let cvtAPIData = convertAPIData(json.CustomerTags)
                            dispatch(
                                custTagsAPIDataAdded({
                                    assetFields: json.AssetFields,
                                    data: cvtAPIData,
                                    serviceTypes: json.ServiceTypes,
                                })
                            )
                        } else {
                            dispatch(
                                custTagsAPIDataAdded({
                                    assetFields: [],
                                    data: [],
                                    serviceTypes: [],
                                })
                            )
                        }
                    })
                    .catch((e) => {
                        //alert('***Error*** ' + e.message)
                        //dispatch(custTagsAPIDataAdded({data: [], serviceTypes: []}));
                        // Redirect to Login Page
                        let redirectURL = getAPIURL().replace('/webapi/', '') + '/logon.aspx'
                        if (redirectURL.toUpperCase().includes('NET'))
                            redirectURL =
                                getAPIURL().replace('/webapi/', '') + '/masterclient/main.aspx'
                        let originalURL = window.location.href
                        window.location.href =
                            redirectURL + '?Redirect=' + encodeURIComponent(originalURL)
                    })
                    .finally(() => {
                        dispatch(custTreeViewListLoading(false))
                    })
            } else {
                dispatch(custTagsAPIDataAdded({ assetFields: [], data: [], serviceTypes: [] }))
            }
        }
    }, [
        CustomerTagsCriteria,
        criteria,
        dispatch,
        throbberExcelExport,
        throbberDocumentationDownload,
    ])

    function onExpandChange(e) {
        setExpanded(
            e.value ? expanded.filter((id) => id !== e.dataItem.id) : [...expanded, e.dataItem.id]
        )
    }

    function handleDataStateChange(event) {
        // ***Note*** event.data is deprecated.  Use event.dataState instead!!!
        //  This is called for both filter and sort changes!!!!
        // Concatenate arrays on custom filters
        // Manually add and remove old filters for MultiSelect filter...
        let cEvent = { ...event }

        // Custom filters need to recreate entire filter object!
        if (
            event.dataState.filter.length > 0 &&
            event.dataState.filter[0].type !== undefined &&
            event.dataState.filter[0].type.toUpperCase() === 'MULTISELECT'
        ) {
            let idField = event.dataState.field
            // Filter based on alternate id field
            if (event.dataState.field.toUpperCase() === 'PROJECTNAME') idField = 'ProjectID'
            let newFilter = []
            // Add other column filters
            for (var i in dataState.filter) {
                for (var j in dataState.filter[i].filters) {
                    if (dataState.filter[i].filters[j].field !== idField)
                        newFilter.push(dataState.filter[i].filters[j])
                }
            }
            // Add in event filter
            for (i in event.dataState.filter) {
                for (j in dataState.filter[i].filters) {
                    // Value is an array in MultiSelect filter
                    if (Array.isArray(event.dataState.filter[i].filters[j].value)) {
                        if (event.dataState.filter[i].filters[j].value.length > 0) {
                            // Remove pass thru property "type" so we know when a new Multiselect comes thru
                            event.dataState.filter[i].filters[j].type = undefined
                            newFilter = newFilter.concat(event.dataState.filter)
                        }
                    } else {
                        if (event.dataState.filter[i].filters[j].value !== '')
                            newFilter = newFilter.concat(event.dataState.filter)
                    }
                }
            }
            cEvent.dataState.filter = newFilter
        }
        // Criple and restrict sort to only the last column clicked
        if (event.dataState.sort.length > 1) {
            let newSort = event.dataState.sort[event.dataState.sort.length - 1]
            cEvent.dataState.sort = []
            cEvent.dataState.sort.push(newSort)
        }
        dispatch(custTagsDataStateChanged(cEvent.dataState))
    }

    function handleFilterChange(event) {
        let cEvent = {
            filter: event.filter,
            field: event.field,
            sort: dataState.sort,
        }
        dispatch(custTagsDataStateChanged(cEvent))
    }

    const handleSparePoolChange = () => {
        setShowSparePool(!showSparePool)
    }
    function onColumnResize(event) {
        if (table) {
            table.style.width = `${event.totalWidth}px`
        }
        if (event.end) {
            dispatch(custTagsColumnsChanged(event.columns))
        }
    }

    function onColumnReorder(event) {
        dispatch(custTagsColumnsChanged(event.columns))
    }
    // if (excludeScrapped) {
    //     compositeFilter.push({
    //         field: 'Disposition',
    //         operator: 'neq',
    //         value: 'Scrapped',
    //     })
    //     // Weird logic in place for
    //     // Scenario: If only the parent record matches the filter, it's child records will not be shown.
    //     // We remove child logs (history) if only the parent record matches
    //     data.map((d) => {
    //         if (d.Log) {
    //             const newLog = d.Log.filter((l) => l.Disposition !== 'Scrapped')
    //             return newLog
    //         }
    //     })
    // }
    // if (excludeSpare) {
    //     compositeFilter.push({
    //         field: 'Disposition',
    //         operator: 'neq',
    //         value: 'Spare',
    //     })
    //     data.map((d) => {
    //         if (d.Log) {
    //             const newLog = d.Log.filter((l) => l.Disposition !== 'Spare')
    //             return newLog
    //         }
    //     })
    // }

    function processData() {
        var i, j
        let compositeFilter = []
        let newData = data
        for (i in dataState.filter) {
            for (j in dataState.filter[i].filters) {
                if (Array.isArray(dataState.filter[i].filters[j].value)) {
                    let filters = []
                    for (let k in dataState.filter[i].filters[j].value) {
                        filters.push({
                            field: dataState.filter[i].filters[j].field,
                            operator: 'eq',
                            value: dataState.filter[i].filters[j].value[k],
                        })
                    }
                    if (filters.length > 0) compositeFilter.push({ logic: 'or', filters: filters })
                } else {
                    // Single-value filters
                    let flt = _.cloneDeep(dataState.filter[i].filters[j])
                    // Modify boolean filters that are "eq" : false to "ne" : true
                    if (flt.value === false && flt.operator === 'eq') {
                        flt.operator = 'neq'
                        flt.value = true
                    }
                    compositeFilter.push(flt)
                }
            }
        }

        // ! Probably want this to be last filter change since it wraps existing logic !
        // if searched use tag in existing filter or taguid was searched.
        if (CustomerTagsCriteria.searchedTagUID)
            compositeFilter = [
                {
                    logic: 'or',
                    filters: [
                        ...compositeFilter,
                        {
                            field: 'TagUID',
                            operator: 'eq',
                            value: CustomerTagsCriteria.searchedTagUID,
                        },
                    ],
                },
            ]
        if (showSparePool) {
            compositeFilter.push({
                field: 'Disposition',
                operator: 'eq',
                value: 'Spare',
            })
            newData = data.map((obj) => {
                const { Log, ...rest } = obj
                return rest
            })
            // data.map((d) => {
            // if (d.Log) {
            // const newLog = d.Log.filter((l) => l.Disposition !== 'Spare')
            // return newLog
            // }
            // })
        }
        let filteredData = filterBy([...newData], compositeFilter, subItemsField) //change "" to subItemsField to filter into history
        if (filteredData.length > 1) {
            const tempData = []
            filteredData.forEach((data) => {
                tempData.push(data.OrderTagId)
            })

            filteredTreeData.current = tempData
        }
        let sortedData = orderBy(filteredData, dataState.sort, subItemsField)
        let expandData = addExpandField(sortedData)

        // Update tag statistics
        let tags = 0
        let events = 0
        for (i in filteredData) {
            tags += 1
            events += 1
            for (j in filteredData[i].Log) {
                events += 1
            }
        }

        return { data: expandData, tagCount: tags, tagEvents: events }
    }

    function addExpandField(dataTree) {
        return mapTree(dataTree, subItemsField, (item) =>
            extendDataItem(item, subItemsField, {
                [expandField]: expanded.includes(item.id),
            })
        )
    }

    function exportToExcel() {
        const todayDate = new Date().toLocaleDateString()
        if (CustomerTagsCriteria.SelectedCustomerSites.Entities.length > 1) {
            setVisualizationTitle(`MULTIPLE ACCOUNTS_${todayDate}`)
        } else if (CustomerTagsCriteria.SelectedCustomerSites.Entities.length === 1) {
            if (CustomerTagsCriteria.SelectedCustomerSites.Entities[0].AllSites) {
                setVisualizationTitle(
                    `${CustomerTagsCriteria.SelectedCustomerSites.Entities[0].EntityName}_${todayDate}`
                )
            } else {
                if (CustomerTagsCriteria.SelectedCustomerSites.Entities[0].Sites.length === 1) {
                    setVisualizationTitle(
                        `${CustomerTagsCriteria.SelectedCustomerSites.Entities[0].EntityName}, ${CustomerTagsCriteria.SelectedCustomerSites.Entities[0].Sites[0].Site}_${todayDate}`
                    )
                } else {
                    setVisualizationTitle(
                        `${CustomerTagsCriteria.SelectedCustomerSites.Entities[0].EntityName}_${todayDate}`
                    )
                }
            }
        }

        // Allow history to be included if not already selected
        let selectedTags = 0
        let selectedLogs = 0
        let selectedTags_Logs = 0
        for (let i in processedData.data) {
            if (processedData.data[i].Selected) selectedTags += 1
            for (let j in processedData.data[i].Log) {
                if (processedData.data[i].Selected) selectedTags_Logs += 1
                if (processedData.data[i].Log[j].Selected) selectedLogs += 1
            }
        }

        let dataCount = '0'
        if (!showSparePool) {
            dataCount = processedData.tagCount.toString()
        } else {
            dataCount = processedData.data.length.toString()
        }
        let tagsSection = (
            <>
                <input
                    id='selectedTags'
                    className='k-checkbox'
                    type='checkbox'
                    value=''
                    defaultChecked={true}
                    disabled={true}
                    onClick={toggleExcelLogSelection}
                />
                <label htmlFor='selectedTags' className='k-radio-label'>
                    &nbsp;Export{' '}
                    {selectedTags > 0 ? selectedTags.toString() + ' selected' : dataCount} assets
                </label>
            </>
        )

        let graphicalDisplaySection = (
            <>
                <br />
                <input
                    id='graphicalDisplay'
                    className='k-checkbox'
                    type='checkbox'
                    defaultChecked={forceProxy}
                    onClick={(e) => {
                        setForceProxy(e.target.checked)
                    }}
                />
                <label htmlFor='graphicalDisplay' className='k-radio-label'>
                    &nbsp;Export{' '}
                    {selectedTags > 0 ? selectedTags.toString() + ' selected' : dataCount} assets
                    with graphical display
                </label>
            </>
        )

        let sectionType = 'checkbox'
        if (selectedLogs > 0 && selectedTags_Logs !== selectedLogs) sectionType = 'radio'

        let selectedLogsSection = ''
        if (selectedLogs > 0)
            selectedLogsSection = (
                <>
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input
                        id='selectedLogs'
                        className={'k-' + sectionType}
                        type={sectionType}
                        name='LogSelection'
                        value=''
                        defaultChecked={excelExportParams.includeAllSelectedLogs}
                        onClick={toggleExcelLogSelection}
                    />
                    <label htmlFor='selectedLogs' className='k-radio-label'>
                        &nbsp;Include {selectedLogs.toString()} selected historic records
                    </label>
                </>
            )

        let logsSection = ''
        if (
            (processedData.tagEvents - processedData.tagCount > 0 &&
                selectedTags === 0 &&
                selectedLogs === 0) ||
            (selectedTags_Logs > 0 && selectedTags_Logs !== selectedLogs)
        )
            logsSection = (
                <>
                    <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input
                        id='logsSection'
                        className={'k-' + sectionType}
                        type={sectionType}
                        name='LogSelection'
                        value=''
                        defaultChecked={excelExportParams.includeAllLogs}
                        onClick={toggleExcelLogSelection}
                    />
                    <label htmlFor='logsSection' className='k-radio-label'>
                        &nbsp;Include{' '}
                        {selectedTags > 0
                            ? selectedTags_Logs.toString()
                            : (processedData.tagEvents - processedData.tagCount).toString()}
                        &nbsp;historic records
                    </label>
                </>
            )

        let excelExportDiv = (
            <div>
                {tagsSection}
                {graphicalDisplaySection}
                {selectedLogsSection}
                {!showSparePool && logsSection}
            </div>
        )
        setExcelExportDialog({ visible: true, excelExportDiv: excelExportDiv })
    }

    function toggleExcelLogSelection(e) {
        if (e.currentTarget.id === 'logsSection') {
            setExcelExportParams({
                includeAllLogs: e.currentTarget.checked,
                includeAllSelectedLogs: excelExportParams.includeAllSelectedLogs,
            })
        } else {
            setExcelExportParams({
                includeAllLogs: excelExportParams.includeAllLogs,
                includeAllSelectedLogs: e.currentTarget.checked,
            })
        }
    }

    function closeExcelExportDialog() {
        setExcelExportDialog({ visible: false, excelExportDiv: '' })
    }

    function submitRequestedExcelExport(e) {
        // current
        var i
        setThrobberExcelExport({ status: 'Exporting', isExporting: true })

        // Add disclaimer in footer
        const options = _export.workbookOptions()
        const rows = options.sheets[0].rows
        const cols = options.sheets[0].columns
        options.sheets[0].filter.from = 0
        options.sheets[0].title = 'Data' // Title for page 1

        // 2nd worksheet stuff
        if (forceProxy) {
            options.sheets.push({
                title: 'Graphical Display', // Title for page 2
            })
        }

        // Check if history is requested
        // If history is requested the header row will have 2 less cells than the history row
        let showHistory = false
        let headerRowLength = rows[0].cells.length
        let maxDatatRowLength = 0
        for (i in rows) {
            if (rows[i].cells.length > maxDatatRowLength) maxDatatRowLength = rows[i].cells.length
        }
        if (maxDatatRowLength - headerRowLength === 2) showHistory = true

        const footerRow = {
            type: 'footer',
            height: 35,
            cells: [
                {},
                {},
                {
                    colSpan: 6,
                    value: 'Note: Time sensitive data that was available at the time of the export',
                    fontSize: 18,
                    verticalAlign: 'center',
                    color: '#FF0000',
                },
            ],
        }
        rows.push([])
        rows.push(footerRow)

        function isValidDate(str) {
            // optional condition to eliminate the tricky ones
            // since chrome will prepend zeros (000...) to the string and then parse it
            if (typeof str !== 'string') {
                return false
            }
            let noSpace = str.replace(/\s/g, '')
            if (noSpace.length < 3) {
                return false
            }
            var re = new RegExp('^(\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}.*\\d*)Z$')
            if (re.test(noSpace)) {
                return Date.parse(noSpace) > 0
            } else {
                return false
            }
        }
        // Reconfigure Export for with and without history
        if (showHistory) {
            cols.splice(0, 1) // Remove 1st column
            rows[0].cells.splice(0, 0, {
                firstCell: true,
                background: '#7a7a7a',
                color: '#fff',
                value: 'Historical',
            }) // delete zero elements before element 0 and add new cell
            rows[0].cells[0].textAlign = 'center'
            rows[0].cells[1].colSpan = 1
            rows[0].cells[1].firstCell = false
            for (i in rows) {
                if (i > 0 && rows[i].cells !== undefined) {
                    if (rows[i].cells[1].colSpan === 2) {
                        rows[i].cells[1].colSpan = 1
                        rows[i].cells[0].background = undefined
                    } else {
                        // A History Row...
                        rows[i].cells.splice(0, 1) // remove 1st cell
                        rows[i].cells[0].value = '-'
                        rows[i].cells[0].textAlign = 'right'
                        let j = 0
                        for (j in rows[i].cells) {
                            rows[i].cells[j].background = undefined
                            rows[i].cells[j].color = '#9b9b9b'
                            rows[i].cells[j].italic = true
                        }
                    }
                }
                if (rows[i].type === 'data') {
                    for (let j in rows[i].cells) {
                        if (isValidDate(rows[i].cells[j].value)) {
                            rows[i].cells[j].value = formatDate(
                                new Date(rows[i].cells[j].value),
                                'MM/dd/yy'
                            )
                        }
                    }
                }
            }
            options.sheets[0].columns[0] = {
                width: 10,
                autoWidth: true,
            }
            options.sheets[0].columns[1].width = 7
            for (i in rows) {
                let index = 3
                const headerAssetNumberObj = {
                    background: '#7a7a7a',
                    color: '#fff',
                    value: 'Asset Number',
                    colSpan: 1,
                    firstCell: false,
                    rowSpan: 1,
                }
                const assetNumberObj = { value: data[i] ? data[i].AssetNumber : '' }
                if (rows[i].type === 'header') {
                    // get index of process unit
                    for (let j in rows[i].cells) {
                        if (rows[i].cells[j].value === 'Process Unit') {
                            index = parseInt(j) + 1
                        }
                    }
                    rows[i].cells.splice(index, 0, headerAssetNumberObj)
                } else {
                    if (i > 0 && rows[i].cells !== undefined) {
                        rows[i].cells.splice(index, 0, assetNumberObj)
                    }
                }
            }
        } else {
            cols.splice(0, 1) // Remove 1st column
            rows[0].cells[0].colSpan = 1

            for (i in rows) {
                if (i > 0 && rows[i].cells !== undefined) {
                    rows[i].cells.splice(0, 1) // remove 1st cell
                }
                if (rows[i].type === 'data') {
                    for (let j in rows[i].cells) {
                        if (isValidDate(rows[i].cells[j].value)) {
                            rows[i].cells[j].value = formatDate(
                                new Date(rows[i].cells[j].value),
                                'MM/dd/yy'
                            )
                        }
                    }
                }
            }

            // add asset # header + columns after process unit
            for (i in rows) {
                let index = 3
                const headerAssetNumberObj = {
                    background: '#7a7a7a',
                    color: '#fff',
                    value: 'Asset Number',
                    colSpan: 1,
                    firstCell: false,
                    rowSpan: 1,
                }
                const assetNumberObj = { value: data[i] ? data[i].AssetNumber : '' }
                if (rows[i].type === 'header') {
                    // get index of process unit
                    for (let j in rows[i].cells) {
                        if (rows[i].cells[j].value === 'Process Unit') {
                            index = parseInt(j) + 1
                        }
                    }
                    rows[i].cells.splice(index, 0, headerAssetNumberObj)
                } else {
                    if (i > 0 && rows[i].cells !== undefined) {
                        rows[i].cells.splice(index, 0, assetNumberObj)
                    }
                }
            }
        }
        closeExcelExportDialog()

        window.onbeforeunload = null
        e.preventDefault()
        _export.save(options)
    }

    function handleExportComplete() {
        setThrobberExcelExport({ status: 'Success', isExporting: false })
    }

    const loadingPanel = (
        <div className='k-loading-mask'>
            <span className='k-loading-text'>Loading</span>
            <div className='k-loading-image'></div>
            <div className='k-loading-color'></div>
        </div>
    )

    // function toggleMoreLess() {

    //     let newColumnsFullDisplay = true;
    //     if (columnsFullDisplay !== undefined ) newColumnsFullDisplay=!columnsFullDisplay;
    //     dispatch(custTagsColumnsFullDisplayChanged(newColumnsFullDisplay));
    // }

    // const columnsMoreLessIcon =
    //     (columnsFullDisplay !== undefined && columnsFullDisplay) ?
    //     <Button icon="folder" onClick={toggleMoreLess} title="Display Fewer Columns">Less</Button>
    //     :
    //     <Button icon="fields-more" onClick={toggleMoreLess} title="Display All Columns">More</Button>;

    function isDocumentation() {
        let isDocs = false
        for (let i in data) {
            if (data[i].TestReport || data[i].OtherReports) {
                isDocs = true
                break
            }
            for (let j in data.Logs) {
                if (data[i].Logs[j].TestReport || data[i].Logs[j].OtherReports) {
                    isDocs = true
                    break
                }
            }
            if (isDocs) break
        }
        return isDocs
    }

    function downloadDocumentation(apiParams) {
        let genDoc_url = getAPIURL() + 'lcm/generateDocumentationZip'
        setThrobberDocumentationDownload({
            status: 'Downloading',
            isDownloading: true,
        })
        fetch(genDoc_url, {
            credentials: 'include',
            method: 'post',
            body: JSON.stringify(apiParams),
            headers: { 'Content-type': 'application/json' },
        })
            .then((resp) => {
                if (resp.ok) {
                    return resp.json()
                } else throw new Error('bad request ' + resp.statusText)
            })
            .then((json) => {
                if (json.errorMessage.length === 0) {
                    setThrobberDocumentationDownload({
                        status: 'Success',
                        isDownloading: false,
                    })
                    //window.location.href = json.url;  Don't use!  //Causes unloading with message
                    window.open(json.url)
                } else {
                    setThrobberDocumentationDownload({
                        status: 'Error',
                        isDownloading: false,
                    })
                    alert(json.errorMessage)
                }
            })
            .catch((e) => {
                setThrobberDocumentationDownload({
                    status: 'Error',
                    isDownloading: false,
                })
                alert(e.message)
            })
    }

    // Excel Export Filename
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    var yyyy = today.getFullYear()
    const ExcelFileName = 'AWC Insight - ' + mm + '_' + dd + '_' + yyyy
    const [visualizationTitle, setVisualizationTitle] = useState(ExcelFileName)
    const [forceProxy, setForceProxy] = useState(true)

    function isSelected() {
        // For Excel Export and Documentation Downloads
        let selectedOrderTagIds = []
        let rowSelected = false
        let testReportSelected = false
        let otherReportsSelected = false
        for (let i in data) {
            if (data[i].Selected) {
                rowSelected = true
                selectedOrderTagIds.push(data[i].OrderTagId)
                if (data[i].TestReport) testReportSelected = true
                if (data[i].OtherReports) otherReportsSelected = true
            }
            for (let j in data[i].Log) {
                if (data[i].Log[j].Selected) {
                    rowSelected = true
                    selectedOrderTagIds.push(data[i].Log[j].OrderTagId)
                    if (data[i].Log[j].TestReport) testReportSelected = true
                    if (data[i].Log[j].OtherReports) otherReportsSelected = true
                }
            }
        }
        return {
            rowSelected: rowSelected,
            testReportSelected: testReportSelected,
            otherReportsSelected: otherReportsSelected,
            selectedOrderTagIds: selectedOrderTagIds,
        }
    }

    function selectExcelFilter(ssData) {
        // Create new instance of the data...
        let ssDataStr = JSON.stringify(ssData)
        let ssNewData = JSON.parse(ssDataStr)

        //treeToFlat - copies log records to parent level and adds level field =0 parent; =1 child
        // treeToFlat(ssData, expandField, subItemsField);

        // Selected Tags
        if (isSelected().rowSelected) {
            let filteredData = []
            // All Logs of Selected Tags
            if (excelExportParams.includeAllLogs) {
                for (let i in ssNewData) {
                    if (ssNewData[i].Selected) {
                        filteredData.push(ssNewData[i])
                        filteredData[filteredData.length - 1].level = 0
                        filteredData[filteredData.length - 1].expanded = true
                        for (let j in ssNewData[i].Log) {
                            filteredData.push(ssNewData[i].Log[j])
                            filteredData[filteredData.length - 1].level = 1
                            filteredData[filteredData.length - 1].expanded = true
                        }
                    }
                }
                return filteredData
            } else if (excelExportParams.includeAllSelectedLogs) {
                // Only selected logs of selected tags
                for (let i in ssNewData) {
                    if (ssNewData[i].Selected) {
                        filteredData.push(ssNewData[i])
                        filteredData[filteredData.length - 1].level = 0
                        filteredData[filteredData.length - 1].expanded = true
                        for (let j in ssNewData[i].Log) {
                            if (ssNewData[i].Log[j].Selected) {
                                filteredData.push(ssNewData[i].Log[j])
                                filteredData[filteredData.length - 1].level = 1
                                filteredData[filteredData.length - 1].expanded = true
                            }
                        }
                    }
                }
                return filteredData
            } else {
                // Only selected tags no logs
                for (let i in ssNewData) {
                    if (ssNewData[i].Selected) {
                        filteredData.push(ssNewData[i])
                        filteredData[filteredData.length - 1].level = 0
                        filteredData[filteredData.length - 1].expanded = true
                    }
                }
                return filteredData
            }
        }
        // Not selected (=> All Tags) with All Logs
        else if (excelExportParams.includeAllLogs) {
            let filteredData = []
            for (let i in ssNewData) {
                filteredData.push(ssNewData[i])
                filteredData[filteredData.length - 1].level = 0
                filteredData[filteredData.length - 1].expanded = true
                for (let j in ssNewData[i].Log) {
                    filteredData.push(ssNewData[i].Log[j])
                    filteredData[filteredData.length - 1].level = 1
                    filteredData[filteredData.length - 1].expanded = true
                }
            }
            return filteredData
        }
        // Not selected (=> All Tags) without Logs
        else {
            // leave out expandField parameter to omit logs
            return treeToFlat(ssNewData, '', subItemsField)
        }
    }

    function ddlDownloadValueRender(element, value) {
        let selection = isSelected()
        let style =
            selection.testReportSelected || selection.otherReportsSelected
                ? { backgroundColor: '#0080ff', color: 'white' }
                : {}
        const valueChildren = (
            <span
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    margin: 2,
                }}
            >
                {element.props.children}
            </span>
        )
        return React.cloneElement(element, { ...element.props, style: style }, valueChildren)
    }

    function ddlDownloadItemRender(li, itemProps) {
        let itemClass = itemProps.dataItem.Disabled ? 'k-disabled' : ''
        let bgColor = itemProps.dataItem.Disabled ? 'initial' : ''
        let iconSpan = <span className={itemProps.dataItem.Icon} style={{ marginRight: 6 }} />
        const itemChildren = (
            <span
                className={itemClass}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    margin: 2,
                }}
            >
                {iconSpan}
                <span className={itemClass} style={{ display: 'flex', flex: 1 }}>
                    {li.props.children}
                </span>
            </span>
        )
        return React.cloneElement(
            li,
            { ...li.props, style: { backgroundColor: bgColor } },
            itemChildren
        )
    }

    function ddlDownloadItemChange(event) {
        if (!event.value.Disabled) {
            let bDefault = false
            let reportTypes = []
            switch (event.value.Name) {
                case 'Test Report':
                    reportTypes = [1]
                    break
                case 'All Documentation (.zip)':
                    reportTypes = []
                    break
                default:
                    bDefault = true
            }
            if (!bDefault) {
                let apiParams = {
                    orderTagIds: isSelected().selectedOrderTagIds,
                    reportTypes: reportTypes,
                }
                downloadDocumentation(apiParams)
            }
        }
    }

    const [selectedButton, setSelectedButton] = useState('All')

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName)
        if (buttonName === 'All') {
            setShowSparePool(false)
            clearFilters()
        } else {
            clearFilters()

            setShowSparePool(true)
            let newDataState = { ...dataState }
            const filters = [
                {
                    field: 'Disposition',
                    value: ['Spare'],
                    operator: (current, values) => values.includes(current),
                },
            ]
            newDataState.filter = [{ filters, Logic: 'eq' }]
            dispatch(custTagsDataStateChanged(newDataState))
            dispatch(custTagsColumnsChanged(initColumns()))
        }
    }
    // const [activeTab, setActiveTab] = useState('home-tab2')

    // const handleTabClick = (tabId) => {
    //     setActiveTab(tabId)
    // }
    function DownLoad() {
        let items = []
        let selection = isSelected()
        let selectedOrderTagIds = selection.selectedOrderTagIds
        if (
            selectedOrderTagIds.length < 1 ||
            (!selection.testReportSelected && !selection.otherReportsSelected)
        ) {
            items.push({
                Icon: '',
                Name: '(No assets with documentation were selected for download)',
                Disabled: false,
            })
            items.push({
                Icon: 'k-icon k-i-txt',
                Name: 'Test Report',
                Disabled: true,
            })
            items.push({
                Icon: 'k-icon k-i-file',
                Name: 'All Documentation (.zip)',
                Disabled: true,
            })
        } else if (selectedOrderTagIds.length > 200) {
            items.push({
                Icon: '',
                Name: '(Please limit your selection to 200 or fewer tags!)',
                Disabled: false,
            })
            items.push({
                Icon: 'k-icon k-i-txt',
                Name: 'Test Report',
                Disabled: true,
            })
            items.push({
                Icon: 'k-icon k-i-file',
                Name: 'All Documentation (.zip)',
                Disabled: true,
            })
        } else {
            items.push({
                Icon: 'k-icon k-i-txt',
                Name: 'Test Report',
                Disabled: !selection.testReportSelected,
            })
            items.push({
                Icon: 'k-icon k-i-file',
                Name: 'All Documentation (.zip)',
                Disabled: !selection.otherReportsSelected,
            })
        }

        // Must have at least one Test Document or Other Document
        let style =
            selection.testReportSelected || selection.otherReportsSelected
                ? { backgroundColor: '#0080ff' }
                : {}

        return (
            <DropDownList
                data={items}
                textField='Name'
                dataItemKey='Name'
                value={{ Icon: '', Name: 'Download', Disabled: false }}
                itemRender={ddlDownloadItemRender}
                valueRender={ddlDownloadValueRender}
                onChange={ddlDownloadItemChange}
                disabled={!isDocumentation()}
                style={style}
                className='insight-Dropdown'
            />
        )
    }

    // Render-------------------------------------------------------------------
    let processedData = processData()
    let bRowsSelected = isSelected().rowSelected
    if (clearFiltersRequested) {
        clearFilters()
        dispatch(custTagsClearFiltersChanged(false))
    }

    let assetTitle =
        'Change the asset view to include additional columns specific to the selected asset type.'

    let enableClearFilters =
        (showSparePool && dataState.filter.length > 1) ||
            (!showSparePool && dataState.filter.length > 0) ||
            CustomerTagsCriteria.SelectedCustomerTags.length > 0 ||
            (assetSelected !== undefined && assetSelected.ID > -1) ||
            bRowsSelected
            ? true
            : false

    // set Dirty if clear filters is active
    if (!isDirty && enableClearFilters) dispatch(appIsDirtyChanged(true))

    return (
        <>
            {' '}
            {(lastDataRetrieval < lastDataRequest ||
                throbberExcelExport.isExporting ||
                throbberDocumentationDownload.isDownloading) &&
                loadingPanel}
            <AutoSizer>
                {({ height, width }) => (
                    <ExcelExport
                        data={selectExcelFilter(processedData.data)}
                        columns={columns}
                        ref={(exporter) => set_Export(exporter)}
                        onExportComplete={handleExportComplete}
                        fileName={ExcelFileName}
                        hierarchy={true}
                        filterable={true}
                        hidden={true}
                        forceProxy={forceProxy}
                        proxyURL={`${getAPIURL()}lcm/insightvisualization?title=${encodeURIComponent(
                            visualizationTitle
                        )}`}
                    ><div className='customerTags'>
                        <TreeList
                            style={{ height: height, width: width, overflow: 'auto' }}
                            tableProps={{ ref: (table) => setTable(table) }}
                            //tableProps={{ ref: table => setTable(table), style: { tableLayout: 'fixed' } }}  //for use with column virtualization (slower)
                            rowHeight={40}
                            scrollable='virtual'
                            //columnVirtualization={true}  // runs slow with column virtualization
                            expandField={expandField}
                            selectedField={selectField}
                            subItemsField={subItemsField}
                            onExpandChange={onExpandChange}
                            sortable={{ mode: 'multiple' }}
                            {...dataState}
                            filterable={false}
                            data={processedData.data}
                            onDataStateChange={handleDataStateChange}
                            columns={columns}
                            columnMenuFilter={dataState.filter}
                            onColumnMenuFilterChange={handleFilterChange}
                            resizable={false}
                            onColumnResize={onColumnResize}
                            reorderable={true}
                            onColumnReorder={onColumnReorder}
                            onRowClick={onRowClick}
                            toolbar={
                                CustomerTagsCriteria.SelectedOrderDetailId === -1 &&
                                <TreeListToolbar>
                                    <div style={{ width: '100%', display: 'block' }}>
                                        <div className='breadcrumb-container'>
                                            <button
                                                className={`breadcrumb-button ${selectedButton === 'All' && 'selected'
                                                    }`}
                                                onClick={() => handleButtonClick('All')}
                                            >
                                                <span
                                                    className={`tabTitle ${selectedButton === 'All' && 'selected'
                                                        }`}
                                                >
                                                    View All Assets
                                                </span>
                                            </button>
                                            <button
                                                className={`breadcrumb-button ${selectedButton === 'Spares' && 'selected'
                                                    }`}
                                                onClick={() => handleButtonClick('Spares')}
                                            >
                                                <span
                                                    className={`tabTitle ${selectedButton === 'Spares' && 'selected'
                                                        }`}
                                                >
                                                    View Spare Pool
                                                </span>
                                            </button>
                                        </div>
                                        <br></br>
                                        <AssetInfo
                                            showSparePool={showSparePool}
                                            processedData={processedData}
                                        />
                                        {/* <div>
                                        {columnsMoreLessIcon}
                                    </div> */}
                                    </div>
                                    <div style={{ width: '100%', display: 'flex' }}>
                                        <div style={{ width: '80%', display: 'flex' }}>
                                            <div
                                                title={assetTitle}
                                                style={{ padding: '4px 10px 0px 2px' }}
                                            >
                                                <div
                                                    className='k-icon k-i-info'
                                                    style={{
                                                        fontSize: 'small',
                                                        themeColor: 'info',
                                                        padding: '0px 3px 2px 0px',
                                                    }}
                                                />
                                                Asset View
                                            </div>
                                            <div>
                                                <AssetSelect />
                                            </div>
                                            <div style={{ padding: '0px 15px 0px 18px' }}>
                                                {DownLoad()}
                                            </div>
                                            <div></div>
                                            <div>
                                                {/* <Button
                                                    title="Excel export"
                                                    className={
                                                        processedData.data.length > 0
                                                            ? 'k-button k-primary'
                                                            : 'k-button'
                                                    }
                                                    disabled={
                                                        processedData.data.length > 0 ? false : true
                                                    }
                                                    onClick={exportToExcel}
                                                >
                                                    Export to Excel
                                                </Button> */}
                                                <AWCButton
                                                    type={
                                                        processedData.data.length > 0
                                                            ? BUTTON_TYPES.SECONDARY
                                                            : BUTTON_TYPES.DISABLED
                                                    }
                                                    onClick={exportToExcel}
                                                    style={{ width: 135, height: 30 }}
                                                >
                                                    Export to Excel
                                                </AWCButton>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                width: '20%',
                                                display: 'flex',
                                                justifyContent: 'end',
                                            }}
                                        >
                                            {/* <button
                                                title="Reset All Filters And Sort Orders"
                                                className={
                                                    enableClearFilters
                                                        ? 'k-button k-primary'
                                                        : 'k-button'
                                                }
                                                disabled={!enableClearFilters}
                                                onClick={clearFilters}
                                            >
                                                Clear Filters
                                            </button> */}
                                            <AWCButton
                                                type={
                                                    !enableClearFilters
                                                        ? BUTTON_TYPES.DISABLED
                                                        : BUTTON_TYPES.SECONDARY
                                                }
                                                onClick={clearFilters}
                                                style={{ width: 115, height: 30 }}
                                            >
                                                Clear Filters
                                            </AWCButton>
                                        </div>
                                    </div>
                                </TreeListToolbar>
                            }
                        />
                    </div>
                        <NotificationGroup
                            style={{
                                right: 0,
                                bottom: 20,
                                alignItems: 'flex-start',
                                flexWrap: 'wrap-reverse',
                            }}
                        >
                            <Fade enter={true} exit={true}>
                                {throbberExcelExport.status === 'Success' && (
                                    <Notification
                                        type={{ style: 'success', icon: true }}
                                        closable={true}
                                        onClose={() =>
                                            setThrobberExcelExport({
                                                status: 'stand-by',
                                                isExporting: false,
                                            })
                                        }
                                    >
                                        <span>Your data has been exported.</span>
                                    </Notification>
                                )}

                                {throbberDocumentationDownload.status === 'Success' && (
                                    <Notification
                                        type={{ style: 'success', icon: true }}
                                        closable={true}
                                        onClose={() =>
                                            setThrobberDocumentationDownload({
                                                status: 'stand-by',
                                                isDownloading: false,
                                            })
                                        }
                                    >
                                        <span>Your documentation has been downloaded.</span>
                                    </Notification>
                                )}
                            </Fade>
                        </NotificationGroup>

                        {excelExportDialog.visible && (
                            <Dialog
                                title={
                                    !showSparePool
                                        ? 'Export to Excel'
                                        : 'Export to Excel - Spare Pool'
                                }
                                width={400}
                                onClose={closeExcelExportDialog}
                            >
                                {excelExportDialog.excelExportDiv}
                                <DialogActionsBar layout={'center'}>
                                    <button
                                        type='button'
                                        className='k-button'
                                        onClick={closeExcelExportDialog}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='button'
                                        className='k-button k-primary'
                                        onClick={submitRequestedExcelExport}
                                    >
                                        Export
                                    </button>
                                </DialogActionsBar>
                            </Dialog>
                        )}

                        <AlertDialog />
                    </ExcelExport>
                )}
            </AutoSizer>
            <style>{extendedFieldStyles}</style>
        </>
    )
}
